import GetAnalyticsForMyCompanyRequestModelBase from '../_generated/modelBases/get-analytics-for-my-company-request-model-base';

export default class GetAnalyticsForMyCompanyRequestModel extends GetAnalyticsForMyCompanyRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
